'use client';

import { useUser } from '@auth0/nextjs-auth0';
import {
  deleteSelectedPlan,
  saveSelectedPlan,
  type SelectedPlanStatus,
} from 'actions/Database';
import { MedicareApiPlan } from 'types/api';
import { useAppSelector } from 'lib/hooks';
import { selectAvailabilityState } from 'slices/availabilitySlice';

export const useSelectedPlanPersistence = () => {
  const { user } = useUser();
  const { selectedPlanYear } = useAppSelector(selectAvailabilityState);

  const persistPlan = async (
    plan: MedicareApiPlan,
    status: SelectedPlanStatus
  ) => {
    if (!user) return;
    await saveSelectedPlan(plan, status, plan.planYear ?? selectedPlanYear);
  };

  const removePlan = async (
    planId: string,
    status: SelectedPlanStatus,
    planYear = selectedPlanYear
  ) => {
    if (!user) return;
    await deleteSelectedPlan(planId, status, planYear);
  };

  return { persistPlan, removePlan };
};
